module.exports = "<div class=\"shopping-cart\" routerLink=\"/shopping-cart\">\n\t<i class=\"header__shopping-cart\"></i>\n\t<span class=\"items__number\">{{numberOfItemsInShoppingCart$ | async}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header-components/shopping-cart-header-overview/shopping-cart-header-overview.html
// module id = bNhV
// module chunks = 12